export default {
    sc_setting_title: "Smart Card - Setting",
    sc_setting_smart_card: "Smart Card",
    sc_setting_org_info: "Organization Information",
    sc_setting_form_popup: "Form Pop up",
    sc_setting_email_noti: "Email Notification",
    sc_setting_sms_noti: "SMS Notification",
    sc_setting_autoresponder: "AutoResponder",
    sc_printlist_create: "Create New Card",
    sc_printlist_orginfo: "Organization Information",
    sc_printlist_employee_info: "Employee Information",
    sc_printlist_template: "Template",
    sc_printlist_delete: "Delete",
    sc_printlist_edit_card: "Edit Card",
    sc_printlist_profile: "Profile",
    sc_printlist_add: "+ Add",
    sc_printlist_new_card_title: "New Card",
    sc_printlist_limit_title: "Can't generate any more cards.",
    sc_printlist_limit_text: "Reached the allowed limit, Please contact your administrator at support@marketea.com or Call us at 774-287-3353.",
    sc_printlist_swal_delete_title: "Delete Card?",
    sc_printlist_swal_delete_confirm: "Yes, Delete it!",
    sc_printlist_success: "Success",
    sc_printlist_removed: "Successfully removed!",
}
